import $ from 'jquery';
import { toggleDropdown, showDropdown, hideAllDropdowns } from './dropdown-common';

$(() => {
  $('.dropdown__trigger').click((event) => {
    event.preventDefault();
    event.stopPropagation();
    let trigger = $(event.target);
    toggleDropdown(trigger);
  });

  $('body').click(() => {
    $('.dropdown__body').hide();
  });
});
